import {Factory as AvailableEmailFactory} from '../src/Form/AsyncValidators/AvailableEmail/Factory';
import {Factory as MatchingPasswordsFactory} from '../src/Form/SyncValidators/MatchingPassword/Factory';

export const Providers = [
    MatchingPasswordsFactory,
    AvailableEmailFactory
];
